// Keeps a scrollable container pinned to its bottom while the user is reading
// the newest content, without fighting them once they scroll up: an update only
// re-pins when the viewport was already near the bottom; otherwise it preserves
// the distance from the bottom, so prepended content ("Load earlier messages")
// doesn't yank the viewport.
const PIN_THRESHOLD_PX = 40;

export const ScrollBottom = {
  mounted() {
    this.scrollToBottom();
  },
  beforeUpdate() {
    const el = this.el;
    this.pinned = el.scrollHeight - el.scrollTop - el.clientHeight < PIN_THRESHOLD_PX;
    this.bottomOffset = el.scrollHeight - el.scrollTop;
  },
  updated() {
    if (this.pinned) {
      this.scrollToBottom();
    } else {
      this.el.scrollTop = this.el.scrollHeight - this.bottomOffset;
    }
  },
  scrollToBottom() {
    let element = this.el;
    element.scrollTop = element.scrollHeight;
  },
};
